export default "__VITE_ASSET__0d539df1__"